import React from "react";

const MenuCollapseIcon = ({width, height}) => {
  return (
    <svg
      width={width || "16"}
      height={height || "17"}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29365 3.72266C7.68428 3.33203 8.31865 3.33203 8.70928 3.72266L14.7093 9.72266C15.0999 10.1133 15.0999 10.7477 14.7093 11.1383C14.3187 11.5289 13.6843 11.5289 13.2937 11.1383L7.9999 5.84453L2.70615 11.1352C2.31553 11.5258 1.68115 11.5258 1.29053 11.1352C0.899902 10.7445 0.899902 10.1102 1.29053 9.71953L7.29053 3.71953L7.29365 3.72266Z"
        fill="#595959"
      />
    </svg>
  );
};

export default MenuCollapseIcon;